export const UI_LONG_PRESS_DURATION = 600;
